'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MessageStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  theme: _propTypes2.default.object
};

var styleProps = function styleProps(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.checkbox.errorMessage,
      messageCheckboxSpacing = _theme$reactackle$com.messageCheckboxSpacing,
      lineHeight = _theme$reactackle$com.lineHeight,
      fontSize = _theme$reactackle$com.fontSize,
      fontColor = _theme$reactackle$com.fontColor;
  var checkboxSize = (0, _reactackleCore.getValueString)(theme.reactackle.components.checkbox.input.size);
  var checkboxTextSpacing = (0, _reactackleCore.getValueString)(theme.reactackle.components.checkbox.label.checkboxTextSpacing);
  var offset = 'calc(' + checkboxSize + ' + ' + checkboxTextSpacing + ')';
  return (0, _styledComponents.css)(['padding-left:', ';font-size:', ';color:', ';line-height:', ';margin-top:', ';'], offset, (0, _reactackleCore.getValueString)(fontSize), fontColor, lineHeight, (0, _reactackleCore.getValueString)(messageCheckboxSpacing));
};

var MessageStyled = exports.MessageStyled = _styledComponents2.default.div.withConfig({
  displayName: 'MessageStyled'
})(['', ';', ';'],
/* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */
'', styleProps);

MessageStyled.propTypes = propTypes;
MessageStyled.displayName = 'MessageStyled';